module.exports = __webpack_public_path__ + "img/dp-portfolio-04.494f1ea0.jpg";